export default __webpack_public_path__ + "static/media/home-icon-active.162fe53f.webp";